<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('fota.title')}}</h2>
        <div class="irinox-form fota" >
          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('fota.search')" style="width:70px" @update:modelValue="freeSearch" :aria-label="$t('fota.search')"/>
            <i class="pi pi-times" @click="() => {filters['global'].value=null; freeSearch();}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="category" v-model="filters['category'].value" :options="categories" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_category_ph')" :aria-label="$t('fota.filter_category_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_model_ph')" :aria-label="$t('fota.filter_model_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="country" v-model="filters['country'].value" :options="countries" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_country_ph')" :aria-label="$t('fota.filter_country_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="firmwareVersions" v-model="filters['firmwareDesired'].value" :options="firmwareVersions" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_firmware_ph')" :aria-label="$t('fota.filter_firmware_ph')" />
            </div>
            <div v-if="!single" class="p-field">
              <Dropdown id="domains" v-model="filters['brandName'].value" :options="domains" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_brand_ph')" :aria-label="$t('fota.filter_brand_ph')" />
            </div>
            <div class="p-field">
              <ToggleButton v-model="single" :onLabel="$t('fota.filter_single')" :offLabel="$t('fota.filter_global')"  :disabled="false" :aria-label="$t('fota.filter_single') + ' / ' + $t('fota.filter_global')"/>      
            </div>
          </div>
        
          <DataTable :value="firmwares" stripedRows 
            responsiveLayout="stack" 
            breakpoint="960px"
            :autoLayout="true" :sortField="single?'serialNumber':'modelNumber'" :sortOrder="1"
            :lazy="true" :paginator="true" paginatorPosition="bottom"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords"
            @update:first="reloadCurrent"
            :currentPageReportTemplate="'{totalRecords} ' + $t('fota.counter')">
            <template #empty>
                {{$t('fota.empty_list')}}
            </template>

            <Column v-if="single" field="serialNumber" :header="$t('fota.col_serialNumber')" ></Column>
            <Column field="category" :header="$t('fota.col_category')" >
              <template #body="slotProps">
                <span>{{$t('dashboard.categories.'+slotProps.data.category)}}</span>
              </template>
            </Column>
            <Column field="modelNumber" :header="$t('fota.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                </div>
              </template>
            </Column>
            <Column field="country" :header="$t('fota.col_country')" >
              <template #body="slotProps">
                <span v-if="single">{{getCountryName(slotProps.data.country)}}</span>
                <span v-else :class="{'fota-all':!slotProps.data.country}">{{!slotProps.data.country?$t('fota.all'):getCountryName(slotProps.data.country)}}</span>
              </template>
            </Column>
            <Column field="brandName" :header="$t('fota.col_brand')" >
              <template #body="slotProps">
                <span v-if="single">{{slotProps.data.brandName}}</span>
                <span v-else :class="{'fota-all':!slotProps.data.brandName}">{{!slotProps.data.brandName?$t('fota.all'):slotProps.data.brandName}}</span>
              </template>
            </Column>
            <Column v-if="single" field="firmwareCurrent" :header="$t('fota.col_firmware_current')" ></Column>
            <Column field="firmwareDesired" :header="$t('fota.col_firmware_desired')" >
              <template #body="slotProps">
                <span :class="{'desired':single}">{{slotProps.data.firmwareDesired}}</span>
              </template>
            </Column>

            <Column bodyClass="" class="irinox-table-buttons p-text-right">
              <template #header>
                <span class="sr-only">{{$t('common.actions')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">
                  <img src="assets/irinox/icons/update.svg" @click="updateFota(slotProps.data.original)" v-tooltip.left="$t('fota.tooltip_fota')" :alt="$t('fota.tooltip_fota')"/>
                </div>
              </template>
            </Column>
          </DataTable>
        
        
        </div>
		</div>
	</div>

  
  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('fota.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  
  <!--            -->
  <!-- MANAGE     -->
  <!--            -->
  <FotaManage :visible="dialog.manage" 
    :single="single"
    :item="selected"
    @update:visible="dialog.manage = $event" 
    @click:button="save" />
  <IrinoxDialogDark :visible="dialog.manageSuccess" 
    mode="success" 
    :message="$t('fota.manage_fw.success')"
    :life="3000" 
    @update:visible="dialog.manageSuccess = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import CountryService from '../../service/CountryService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import FotaManage from './FotaManage.vue';
import { mapGetters } from 'vuex';
import {FilterMatchMode} from 'primevue/api';
export default {
    components: {
        IrinoxDialogDark,
        FotaManage,
    },
    data() {
        return {
          countryList: [],
          filters: {
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'category': {value: null, matchMode: FilterMatchMode.EQUALS},
            'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
            'country': {value: null, matchMode: FilterMatchMode.EQUALS},
            'brandName': {value: null, matchMode: FilterMatchMode.EQUALS},
            'firmwareDesired': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          single: false,
          categories: [
            { code: null, name: this.$t('fota.filter_remove') },
            { code: 'ABBATTITORE', name: this.$t('dashboard.categories.ABBATTITORE') },
            { code: 'CONSERVATORE', name: this.$t('dashboard.categories.CONSERVATORE') },
            { code: 'FERMALIEVITA', name: this.$t('dashboard.categories.FERMALIEVITA') },
            { code: 'CAM', name: this.$t('dashboard.categories.CAM') },
          ],
          modelNumbers: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          countries: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          domains: [
            { code: null, name: this.$t('fota.filter_remove') },
            { code: 'IRINOX', name: 'IRINOX' },
          ],
          firmwareVersions: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          firmwares: [],
          selected: null,
          dialog: {
            error: false,
            manage: false,
            manageSuccess: false,
          },
          table: {
            rows: 50,
            totalRecords: 0,
            first: 0
          },
          freeSearchTimer: null,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    watch: {
      single: 'singleGlobalToggle',
      "filters.category.value": 'onDropdownFilterChange',
      "filters.modelNumber.value": 'onDropdownFilterChange',
      "filters.country.value": 'onDropdownFilterChange',
      "filters.firmwareDesired.value": 'onDropdownFilterChange',
      "filters.brandName.value": 'onDropdownFilterChange',
    },
    created() {
      this.countryService = new CountryService();
      this.applianceService = new ApplianceService();
      this.initFilters();
    },
    mounted() {
      this.countryService.getCountries().then((countries) => {
          this.countryList = countries;
      });
      this.singleGlobalToggle();
    },
    methods: {
      reloadGlobal() {
        this.firmwares = [];
        this.applianceService.getFotaModelsV2(this.personaltoken, this.filters, this.table)
          .then((body) => {
            this.table.totalRecords = body.count;
            const firmwares = body.models;
            for(let i=0; i<firmwares.length; i++) {
              let modelNumberTemp = firmwares[i].name + (firmwares[i].accessory?" - "+firmwares[i].accessory:"");
              this.firmwares.push({
                category: firmwares[i].type,
                modelNumber: modelNumberTemp,
                country: firmwares[i].country === "ALL" ? null : firmwares[i].country,
                brandName: firmwares[i].brand,
                firmwareDesired: firmwares[i].desiredFirmware.version,
                original: firmwares[i]
              });
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.firmwares = [];
            this.table.totalRecords = 0;
          });
      },
      reloadSingle() {
        this.firmwares = [];
        this.applianceService.getFotaAppliancesV2(this.personaltoken, this.filters, this.table)
          .then((body) => {
            this.table.totalRecords = body.count;
            const firmwares = body.appliances;
            for(let i=0; i<firmwares.length; i++) {
              let modelNumberTemp = firmwares[i].modelNumber + (firmwares[i].accessory?" - "+firmwares[i].accessory:"");
              this.firmwares.push({
                serialNumber: firmwares[i].serialNumber,
                category: firmwares[i].type,
                modelNumber: modelNumberTemp,
                country: firmwares[i].country,
                brandName: firmwares[i].brandName,
                firmwareCurrent: firmwares[i].currentFirmware,
                firmwareDesired: firmwares[i].desiredFirmware.version,
                original: firmwares[i]
              });
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.firmwares = [];
            this.table.totalRecords = 0;
          });
      },
      initFilters() {
        this.filters = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'category': {value: null, matchMode: FilterMatchMode.EQUALS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'country': {value: null, matchMode: FilterMatchMode.EQUALS},
              'brandName': {value: null, matchMode: FilterMatchMode.EQUALS},
              'firmwareDesired': {value: null, matchMode: FilterMatchMode.EQUALS}
          }
      },
      emptyFilter() {
        return { 
              code: null,
              name: this.$t('fota.filter_remove') 
            };
      },
      loadGlobalFilters() {
        this.applianceService.getFotaModelsFilters(this.personaltoken)
          .then((body) => {
            const models = (body.models || [])
              .map(m => ({ code: { gamma: m.gamma, modelName: m.modelName, accessory: m.accessory }, name: this.$functions.fixModelName(`${m.gamma} ${m.modelName}${m.accessory ? ' - ' + m.accessory : ''}`) }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.modelNumbers = [this.emptyFilter(), ...models];
            const countries = (body.countries || [])
              .map(c => ({ code: c, name: this.getCountryName(c) }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.countries = [this.emptyFilter(), ...countries];
            const firmwares = (body.desiredFirmwareVersions || [])
              .map(v => ({ code: v, name: v }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.firmwareVersions = [this.emptyFilter(), ...firmwares];
          })
          .catch(() => {});
      },
      loadSingleFilters() {
        this.applianceService.getFotaAppliancesFilters(this.personaltoken)
          .then((body) => {
            const models = (body.models || [])
              .map(m => ({ code: { gamma: m.gamma, modelName: m.modelName, accessory: m.accessory }, name: `${m.gamma} ${m.modelName}${m.accessory ? ' - ' + m.accessory : ''}` }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.modelNumbers = [this.emptyFilter(), ...models];
            const countries = (body.countries || [])
              .map(c => ({ code: c, name: this.getCountryName(c) }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.countries = [this.emptyFilter(), ...countries];
            const firmwares = (body.desiredFirmwareVersions || [])
              .map(v => ({ code: v, name: v }))
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            this.firmwareVersions = [this.emptyFilter(), ...firmwares];
          })
          .catch(() => {});
      },
      onDropdownFilterChange() {
        this.table.first = 0;
        this.reloadCurrent();
      },
      singleGlobalToggle() {
        this.initFilters();
        this.modelNumbers = [this.emptyFilter()];
        this.countries = [this.emptyFilter()];
        this.firmwareVersions = [this.emptyFilter()];
        this.table.first = 0;
        this.table.totalRecords = 0;
        if(this.single) {
          this.reloadSingle();
          this.loadSingleFilters();
        } else {
          this.reloadGlobal();
          this.loadGlobalFilters();
        }
      },
      freeSearch() {
        clearTimeout(this.freeSearchTimer);
        this.freeSearchTimer = setTimeout(() => {
          this.table.first = 0;
          this.reloadCurrent();
        }, 1000);
      },
      reloadCurrent() {
        if(this.single) {
          this.reloadSingle();
        } else {
          this.reloadGlobal();
        }
      },
      getCountryName(code) {
        if(code==="ALL") {
          return this.$t('fota.all');
        }
        let country = this.countryList.find(obj => obj.code === code);
        if(country && country.name) {
          return country.name;
        }
        return code;
      },
      updateFota(item) {
        this.selected = item;
        this.dialog.manage = true;
      },
      save(obj) {
        this.dialog.manage = false;
        if(this.single) {
          this.applianceService.updateFirmwareAppliance(this.personaltoken, this.selected.serialNumber, obj.force ? null : obj.desiredFirmware)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.manageSuccess = true;
                this.reloadSingle();
              } else {
                console.error("ERROR "+JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.dialog.error = true;
            });
        } else {
          this.applianceService.updateFirmwareModel(this.personaltoken, this.selected.modelId, obj.desiredFirmware, this.selected.brand, this.selected.country)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.manageSuccess = true;
                this.reloadGlobal();
              } else {
                console.error("ERROR "+JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.dialog.error = true;
            });
        }
      }
    }
}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

span.desired,
span.fota-all
 {
  color: #262626;
  font-style: italic;
}

</style>

<style>

</style>